// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"592":"953d452d8759b189","888":"18c5626cfd2c0090"}[chunkId] + ".css";
};